<template>
  <v-row>
    <v-col cols="12" v-for="(item, index) in messages" :key="index">
      <v-card>
        <v-card-text>
          <p>
            <strong>Topic:</strong>
            {{item.topic}} |
            <strong>Time:</strong>
            {{item.time}}
          </p>
          <pre>{{item.message}}</pre>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
/* eslint-disable */
import mqtt from "mqtt";

export default {
  mounted() {
    this.startMqtt();
  },
  data() {
    return {
      messages: []
    };
  },
  methods: {
    startMqtt() {
      const client = mqtt.connect("mqtt://broker.mqttdashboard.com:8000/mqtt");
      client.on("connect", () => {
        client.subscribe("sumrid", err => {
          if (err) console.error(err);
          else {
            console.info("client connected.");
            client.publish("sumrid/test", "Hello from web client.");
          }
        });
      });

      client.on("message", (topic, message) => {
        const time = new Date().toUTCString();
        let parsedMessage = "";
        try {
          parsedMessage = JSON.parse(message.toString());
        } catch (error) {
          parsedMessage = message;
        }
        this.messages.unshift({ topic, message: parsedMessage, time });
      });
    }
  }
};
</script>